<template>
  <div class="small">
    <div class="logoandtext large">
      <div class="label_tot guida_color">
        GUIDA TOT. {{ minToString(report.guida_tot) }}
      </div>
      <div class="label_tot riposo_color">
        RIPOSO TOT. {{ minToString(report.riposo_tot) }}
      </div>
      <div class="label_tot lavoro_color">
        LAVORO TOT. {{ minToString(report.lavoro_tot) }}
      </div>
      <div class="label_tot disp_color">
        DISPONIBILE TOT. {{ minToString(report.disp_tot) }}
      </div>
      <div class="label_tot err_color">
        ERRORE TOT. {{ minToString(report.err_tot) }}
      </div>
    </div>
  </div>
</template>

<script>
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
export default {
  name: 'TimetableCard',
  mixins: [UtilityMixin],
  props: {
    report: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {}
  },

  mounted() {
    const vm = this

    if (vm.report) {
      if (vm.report.guida.length > 0) {
        vm.startDate = vm.newDate(vm.report.guida[0].from)
        return
      }
      if (vm.report.lavoro.length > 0) {
        vm.startDate = vm.newDate(vm.report.lavoro[0].from)
        return
      }
      if (vm.report.riposo.length > 0) {
        vm.startDate = vm.newDate(vm.report.riposo[0].from)
        return
      }
      if (vm.report.disp.length > 0) {
        vm.startDate = vm.newDate(vm.report.disp[0].from)
        return
      }
    }
    vm.startDate = new Date()
  },
}
</script>
<style scoped>
.small {
  font-size: 10px;
  border-bottom: 1px solid black;
  line-height: 6px;
  font-weight: bold;
  padding: 5px;
}

.large {
  font-size: 14px;
}

.riposo_color {
  color: green;
}

.lavoro_color {
  color: blue;
}

.guida_color {
  color: red;
}

.disp_color {
  color: orange;
}

.err_color {
  color: black;
}
.logoandtext {
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
}
.logoandtext .img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 48px;
}

.logoandtext .img-container img {
  max-height: 32px;
}

.logoandtext .text-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  font-size: 14px;
}

.label_tot {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  font-size: 10px;
}
</style>
